import React, { useState } from 'react'
import {
  channel,
  create,
  discover,
  home,
  store,
  creditsIcon,
  face,
  discoverDark,
  createDark
} from 'shared-ui/assets'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { getUserTheme, getGuestUser } from '../../utils/localStorage'
import { useTheme } from 'styled-components'
import { GuestUserModal, Text, LazyImage } from 'shared-ui/components'
import { useMenu, useUserProfile } from 'shared-ui/hooks'
import { PAGE_NAME, ROUTES } from 'shared-ui/utils/constants'
import { GA_EVENTS } from 'shared-ui/utils/gaConstants'
import { useTrackEvent } from 'shared-ui/utils/analyticEvents'
import { openConsentModal } from '../../redux/reducers/consentReducer'
import { MINI_APP_IDS } from '../../utils/constants/config'

const MobileTabBar = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const user = useSelector((state) => state.auth.user)
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated) || !!localStorage.getItem('access')
  const createConsent = useSelector((state) => state.consent?.miniApps?.[MINI_APP_IDS.CREATE])
  const { data: profilData } = useUserProfile(user?.user_id)
  const theme = useTheme()
  const { data: menuItemData } = useMenu()
  let isUserTab = false
  const [showGuestModal, setShowGuestModal] = useState(false)
  const trackEvent = useTrackEvent()

  // Dynamically add path based on tab title
  const menuItemsWithPaths = menuItemData?.map((tab) => {
    let path = '/' // Default path
    switch (tab.title.toLowerCase()) {
      case 'home':
        path = ROUTES.home
        break
      case 'discover':
        path = ROUTES.discover
        break
      case 'create':
        path = ROUTES.create
        break
      case 'me':
        path = ROUTES.profile
        isUserTab = true
        break
      case 'dashboard':
        path = ROUTES.dashboard
        break
      default:
        path = `/${tab.title.toLowerCase()}` // If no match, fallback to title as path
        break
    }
    return { ...tab, path }
  })

  return (
    <div
      className="fixed left-0 right-0 bottom-0  border-[#23243a] flex justify-around items-center h-[80px] z-50 pb-1"
      style={{ background: theme.app.background }}
    >
      {showGuestModal && (
        <GuestUserModal onClose={() => setShowGuestModal(false)} />
      )}
      {menuItemsWithPaths &&
        menuItemsWithPaths?.map((tab) => {
          const isActive =
            location.pathname === tab.path ||
            (tab.title === PAGE_NAME.Home && location.pathname === '/') ||
            (tab.title === PAGE_NAME.Create &&
              location.pathname === ROUTES.create)
          return (
            <div
              key={tab.id}
              className={`flex flex-col items-center text-xs font-medium cursor-pointer`}
              style={{
                color: isActive ? theme.colors.Blue : theme.app.iconlabel
              }}
              onClick={() => {
                if (tab.path == ROUTES.dashboard && getGuestUser() == 'true') {
                  setShowGuestModal(true)
                  return
                }

                const isGuestUser = !isAuthenticated && getGuestUser() === 'true'
                const tabTitleLower = tab.title?.toLowerCase() || ''
                const isCreateRelated =
                  tab.path === ROUTES.home ||
                  tabTitleLower === 'home' ||
                  tab.path === ROUTES.create ||
                  tabTitleLower === 'create' ||
                  tab.path === ROUTES.discover ||
                  tabTitleLower === 'discover'

                if (isCreateRelated && !isGuestUser) {
                  if (!createConsent?.hasAgreed || !createConsent?.isOn) {
                    dispatch(
                      openConsentModal({
                        miniAppId: MINI_APP_IDS.CREATE,
                        isModalBlocking: false,
                        redirectUrl: tab.path
                      })
                    )
                    return
                  }
                }

                if (tab.path == ROUTES.create)
                  trackEvent(GA_EVENTS.create_entry_opened, {
                    source: 'bottom_nav'
                  })
                if (tab.path == ROUTES.discover)
                  trackEvent(GA_EVENTS.discover_opened, {
                    source: 'bottom_nav'
                  })
                navigate(tab.path)
              }}
            >
              <span className="w-full h-full flex items-center justify-center">
                <span
                  className={`flex items-center justify-center rounded-full w-14 h-8 mb-1 `}
                  style={{
                    background: isActive ? theme.app.tabSelectedicon : ''
                  }}
                >
                  <LazyImage
                    src={tab.image_url}
                    alt={tab.title}
                    className="object-cover w-6 h-6"
                    style={{
                      filter: isActive
                        ? tab.title.toLowerCase() !== 'me' &&
                          'brightness(0) saturate(100%) invert(62%) sepia(98%) saturate(749%) hue-rotate(163deg) brightness(102%) contrast(101%)'
                        : tab.title.toLowerCase() !== 'me' &&
                          theme.app.iconFilter
                    }}
                  />
                </span>
              </span>
              <span
                className="mt-1 text-[12px] font-semibold"
                style={{
                  color: isActive ? theme.app.accent : theme.app.iconlabel
                }}
              >
                {tab.title}
              </span>
            </div>
          )
        })}
    </div>
  )
}

export default MobileTabBar
